<template>
  <!-- PricePro-style filter PANEL (UAT). Rendered inline as a flex sibling of the
       grid so it PUSHES the grid over (no overlap). Filter edits update only the
       local model; nothing is applied to the grid until the user clicks Apply
       (which emits the model). The dashboard keyword search stays live/separate. -->
  <div class="ad-filter-panel d-flex flex-column" style="height:100%;">
    <v-toolbar flat dense color="toolbar" class="flex-grow-0">
      <v-icon left>mdi-filter-variant</v-icon>
      <v-toolbar-title class="text-subtitle-1 font-weight-medium">Filters</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider />

    <div class="pa-4 flex-grow-1" style="overflow-y:auto;">
      <v-autocomplete
        v-model="model.positions"
        :items="positionOptions"
        label="Position"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-model="model.departments"
        :items="departmentOptions"
        label="Department"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-model="model.categories"
        :items="categoryOptions"
        label="Category"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-model="model.subcategories"
        :items="subcategoryOptions"
        label="Subcategory"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-model="model.promoCategories"
        :items="promoCategoryOptions"
        label="Promo Category"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-model="model.vendors"
        :items="vendorOptions"
        label="Vendor"
        multiple chips small-chips deletable-chips clearable
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-text-field
        v-model="model.features"
        label="Feature"
        placeholder="Contains text..."
        clearable
        dense outlined hide-details background-color="input"
        class="mb-4" />
      <v-text-field
        v-model="model.itemIds"
        label="Item ID"
        placeholder="Contains text..."
        clearable
        dense outlined hide-details background-color="input"
        class="mb-4" />
      <v-select
        v-model="model.epayCompetes"
        :items="epayCompeteOptions"
        label="ePay / Competes"
        dense outlined hide-details background-color="input" />
    </div>

    <v-divider />
    <div class="pa-3 d-flex align-center flex-grow-0">
      <v-btn text small :disabled="!activeCount" @click="clearAll">Clear all</v-btn>
      <v-spacer />
      <v-btn color="primary" small @click="apply">Apply</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdPlannerSearchFilters',
  props: {
    value: { type: Object, required: true },
    positionOptions: { type: Array, default: () => [] },
    departmentOptions: { type: Array, default: () => [] },
    promoCategoryOptions: { type: Array, default: () => [] },
    vendorOptions: { type: Array, default: () => [] },
    categoryOptions: { type: Array, default: () => [] },
    subcategoryOptions: { type: Array, default: () => [] },
    epayCompeteOptions: { type: Array, default: () => [] }
  },
  data () {
    return { model: { ...this.value } }
  },
  computed: {
    activeCount () {
      const m = this.model
      let n = 0
      ;['positions', 'departments', 'categories', 'subcategories', 'promoCategories', 'vendors'].forEach(k => {
        if (Array.isArray(m[k])) n += m[k].length
      })
      if ((m.features || '').trim() !== '') n += 1
      if ((m.itemIds || '').trim() !== '') n += 1
      if (m.epayCompetes && m.epayCompetes !== 'all') n += 1
      return n
    }
  },
  watch: {
    value: {
      handler (v) { this.model = { ...v } },
      deep: true
    }
  },
  methods: {
    clearAll () {
      this.model = { positions: [], departments: [], categories: [], subcategories: [], promoCategories: [], vendors: [], features: '', itemIds: '', epayCompetes: 'all' }
      this.emitModel()
    },
    apply () {
      this.emitModel()
      this.$emit('close')
    },
    emitModel () {
      this.$emit('input', { ...this.model })
    }
  }
}
</script>
